import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { Control, Controller, FieldErrors } from 'react-hook-form';

interface ISelectBoxProps {
    name: string;
    id: string;
    label: string;
    defaultValue?: any;
    control: Control<any>;
    errors: FieldErrors<any>; // Errors from react-hook-form
    required?: boolean;
    disabled?: boolean;
    handleChange?: any
    options: Array<IOptionProps>
}

interface IOptionProps {
    key: number | string
    value: string
}

const SelectBox = ({ name, id, label, defaultValue = '', control, errors, required = true, disabled = false, options }: ISelectBoxProps) => {
    return (
        <>
            <FormControl sx={{ m: 1 }} variant="outlined">
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Controller
                    name={name}
                    control={control}
                    defaultValue={defaultValue}
                    render={({ field }) => (
                        <Select
                            {...field}
                            required={required}
                            disabled={disabled}
                            id={id}
                            label={label}
                            value={ field.value ?? defaultValue }
                        >
                            {options.map((option) => (
                                <MenuItem key={option.key} value={option.key}>
                                    {option.value}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
            </FormControl>

        </>
    )
}

export default SelectBox;